import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const ContentContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
}));

export const ContentWrapper = styled("div")(() => ({
  display: "flex",

  width: "100%",
}));

export const HeaderWrapper = styled(ContentWrapper)(() => ({
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: "80px",
}));

export const ItensWrapper = styled(ContentWrapper)(() => ({
  alignItems: "center",
  justifyContent: "space-between",
  gap: "32px 80px",

  flexWrap: "wrap",
}));

export const HeaderText = styled("p")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  maxWidth: "375px",
  width: "100%",
}));

export const StyledIconButton = styled("button")(() => ({
  alignItems: "center",
  display: "flex",
  gap: "8px",

  backgroundColor: colors.brandBlue500,
  border: 0,
  borderRadius: "8px",
  color: `${colors.white} !important`,
  cursor: "pointer",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  height: "40px",
  lineHeight: "20px",
  letterSpacing: "0.1px",
  textAlign: "center",
  textDecoration: "none",
  padding: "10px 20px 10px 16px",

  "&:hover": {
    color: colors.white,
    boxShadow: "0px 1px 3px 1px #00000026",
  },
}));

export const SkeletonWrapper = styled("div")(() => ({
  width: "calc(50% - 40px)",
}));
